// src/components/Admin/ReportManager/ReportItem.jsx
import { TableRow, TableCell, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ReportItem = ({
  report,
  onProcess = () => { },
  onLogView = () => { },
  onShowReporters = () => { },
}) => {
  const navigate = useNavigate();

  /* 상태 라벨 */
  const statusLabel = {
    pending: '대기 중',
    blinded: '블라인드',
    deleted: '삭제',
    ignored: '무시됨',
    restored: '복구됨',
  };

  /* 게시글·댓글 이동 */
  const handleMove = () => {
    if (report.target_comment_id && report.target_post_id) {
      navigate(`/main/posts/${report.target_post_id}#comment-${report.target_comment_id}`);
    } else if (report.target_post_id) {
      navigate(`/main/posts/${report.target_post_id}`);
    } else {
      alert('대상 이동 불가');
    }
  };

  /* 신고자 모달 (닉네임 클릭) */
  const targetId =
    report.target_comment_id || report.target_user_id || report.target_post_id;
  const actualType = report.report_type === 'reply' ? 'comment' : report.report_type;

  const handleReporterClick = () => {
    if (!targetId) {
      alert('대상을 찾을 수 없습니다.');
      return;
    }
    onShowReporters(actualType, targetId);
  };

  return (
    <TableRow>
      {/* 종류 */}
      <TableCell align="center">
        {{
          post: '게시글',
          comment: '댓글',
          reply: '대댓글',
          user: '회원',
        }[report.report_type] || '-'}
      </TableCell>

      {/* 대상 제목 / 이동 */}
      <TableCell>
        {report.target_post_id ? (
          <span
            onClick={handleMove}
            style={{
              cursor: 'pointer',
              color: '#1976d2',
              textDecoration: 'underline',
            }}
          >
            {report.target_title || '제목 없음'}
          </span>
        ) : (
          <em>삭제된 게시글 또는 댓글</em>
        )}
      </TableCell>

      {/* 사유 */}
      <TableCell>{report.reason}</TableCell>

      {/* 신고자 */}
      <TableCell
        align="center"
        sx={{
          color: 'primary.main',
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
        onClick={handleReporterClick}
      >
        {report.reporter || '익명'}
      </TableCell>

      {/* 날짜, 횟수 */}
      <TableCell>{report.created_at}</TableCell>
      <TableCell>{report.report_count || 0}회</TableCell>

      {/* 상태 */}
      <TableCell
        align="center"
        sx={{
          cursor: 'pointer',
          fontWeight: 'bold',
          color: report.status === 'blinded' ? 'error.main' : 'text.primary',
        }}
        onClick={() => onLogView(report.id)}
      >
        {statusLabel[report.status] || report.status}
      </TableCell>

      {/* 처리자 */}
      <TableCell align="center">
        {report.processed_by || <em>미처리</em>}
      </TableCell>

      {/* 관리 버튼들 */}
      <TableCell
        align="center"
        sx={{ width: 140, p: 0.5 }}
      >
        <Stack
          direction="row"
          spacing={0.5}
          flexWrap="wrap"
          justifyContent="center"
        >
          {[
            { label: '블라인드', color: 'secondary', action: 'blinded' },
            { label: '무시', color: 'secondary', action: 'ignored' },
            { label: '복구', color: 'secondary', action: 'restored' },
          ].map(({ label, color, action }) => (
            <Button
              key={action}
              variant="text"
              size="small"
              color={color}
              sx={{
                minWidth: 32,
                px: 0.5,
                fontSize: 13,
                lineHeight: 1.2,
                /* 모바일: 폰트·패딩 축소 */
                '@media (max-width:600px)': {
                  px: 0.4,
                  fontSize: '0.75rem',
                },
              }}
              onClick={() => onProcess(report.id, action)}
            >
              {label}
            </Button>
          ))}
        </Stack>
      </TableCell>
    </TableRow>
  );
};

export default ReportItem;
